import { Space, Table, Tooltip } from 'antd';
import { PermissionContext } from 'components/Global/AuthLayout';
import { useContext } from 'react';
import { DeleteActionSvg, EditActionSvg } from 'utils/svgs';
import styles from './index.module.scss';

const { Column } = Table;

type Props = {
	payGroupData: any;
	totalRecords: number;
	currentPage: number;
	pageSize: number;
	tableChangeHandler: (pagination: any, filter: any, sorter: any) => void;
	setEditData: any;
	openDrawerHandler: any;
	setDrawerInfoHandler: any;
	showModal: any;
	isLoading: boolean;
};

const PayGroupTable = (props: Props) => {
	const {
		payGroupData,
		totalRecords,
		currentPage,
		pageSize,
		tableChangeHandler,
		openDrawerHandler,
		setDrawerInfoHandler,
		setEditData,
		showModal,
		isLoading,
	} = props;
	const permissionContext = useContext(PermissionContext);
	const isEdit =
		permissionContext.allowedPermissions.includes('Edit_Pay_Group');
	const isDelete =
		permissionContext.allowedPermissions.includes('Delete_Pay_Group');

	const editDataHandler = (selectedObj: any) => {
		const currency =
			selectedObj.PayGroupCurrency[0]?.companyCurrency?.id || 'N/A';
		const departments =
			selectedObj.PayGroupDepartments.map(
				(dept: any) => dept.department.id
			) || [];
		const branches =
			selectedObj.PayGroupBranches.map(
				(branch: any) => branch.branch.id
			) || [];
		const employees =
			selectedObj?.PayGroupEmployee?.map((emp: any) => emp.employee.id) ||
			[];
		const employeesName =
			selectedObj?.PayGroupEmployee?.map(
				(emp: any) => emp.employee.firstName
			) || [];
		const name = selectedObj.name;
		const id = selectedObj.id;

		setEditData({
			id,
			name,
			currency,
			departments,
			branches,
			employees,
			employeesName,
		});

		openDrawerHandler();
		setDrawerInfoHandler('Edit Pay Group');
	};

	// Delete user data handler
	const deleteDataHandler = (userObject: any) => {
		setEditData(userObject);
		showModal();
	};

	return (
		<div className={styles['dynamic-table']}>
			<Table
				dataSource={payGroupData}
				scroll={{ y: 'calc(100vh - 360px)' }}
				pagination={{
					total: totalRecords,
					current: currentPage,
					pageSize: pageSize,
					showSizeChanger: false,
					pageSizeOptions: [10, 20, 50, 100, 200],
				}}
				onChange={tableChangeHandler}
				rowKey={(record: any) => record.id}
				loading={isLoading}
			>
				<Column
					title="Name"
					dataIndex="name"
					key="name"
					//	sorter={true}
					className="bg-white"
					width={'25%'}
				/>
				<Column
					title="Currency"
					dataIndex="currency"
					key="currency"
					width={'15%'}
					//	sorter={true}
					className="bg-white"
					render={(text, record: any) =>
						record?.PayGroupCurrency[0]?.companyCurrency
							?.currency || '-'
					}
				/>
				<Column
					title="Department"
					dataIndex="departments"
					key="department"
					className="bg-white"
					width={'25%'}
					render={(text, record: any) => {
						const departmentList = record.PayGroupDepartments?.map(
							(dept: any) => dept.department?.name
						).filter(Boolean);

						const content =
							departmentList.length > 0
								? departmentList.join(' | ')
								: '-';

						return <span>{content}</span>;
					}}
				/>
				<Column
					title="Branch"
					dataIndex="branches"
					key="branch"
					//	sorter={true}
					className="bg-white"
					width={'20%'}
					render={(text, record: any) =>
						record?.PayGroupBranches.map(
							(branch: any) => branch.branch.name
						).join(' | ') || '-'
					}
				/>
				{(isEdit || isDelete) && (
					<Column
						title="Action"
						key="action"
						className="bg-white"
						render={(_: any, data: any) => (
							<Space size={20}>
								{data.isPayGroupEditable && isEdit ? (
									<div
										className="cursor-pointer  flex align-center justify-center"
										onClick={() => editDataHandler(data)}
									>
										<EditActionSvg />
									</div>
								) : (
									<Tooltip title="Cannot edit: no permission or payroll is in draft/pending.">
										<div className="cursor-not-allowed flex align-center justify-center">
											<EditActionSvg color="#928F8F" />
										</div>
									</Tooltip>
								)}
								{data.isPayGroupDeletable && isDelete ? (
									<div
										className="cursor-pointer flex align-center justify-center"
										onClick={() => deleteDataHandler(data)}
									>
										<DeleteActionSvg />
									</div>
								) : (
									<Tooltip title="Cannot delete: no permission or payroll already generated.">
										<div className="cursor-not-allowed flex align-center justify-center">
											<DeleteActionSvg color="#928F8F" />
										</div>
									</Tooltip>
								)}
							</Space>
						)}
					/>
				)}
			</Table>
		</div>
	);
};

export default PayGroupTable;
